export default __webpack_public_path__ + "static/media/212.1b71ac39.jpg";